import { css, keyframes } from 'styled-components'

const shake = keyframes`
  10%, 90% {
    transform: translate3d(-2px, 0, 0);
  }
  
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-3px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(5px, 0, 0);
  }
`
const flip = keyframes`
   0% {
      transform: rotateY(0);
      animation-timing-function: ease-out;
   }
   50% {
      transform: rotateY(90deg);
      animation-timing-function: ease-out;
   }
   100% {
      transform: rotateY(180deg);
      animation-timing-function: ease-in;
   }
`

const shaking = css`
  animation: ${shake} 0.62s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
`
const flipping = css`
  animation: ${flip} 1.2s;
  backface-visibility: hidden;
`

export default {
  shaking,
  flipping
}
